function initializeAleonaStickyCart() {
  document.querySelectorAll('[data-tw-sticky-atc]').forEach(function (bar) {
    if (bar.dataset.initialized === 'true') return;
    var trigger = bar.querySelector('[data-tw-sticky-atc-trigger]');
    var label = bar.querySelector('[data-tw-sticky-atc-label]');
    if (!trigger) return;

    var target = document.getElementById(trigger.getAttribute('data-target'));
    if (!target) return;
    bar.dataset.initialized = 'true';

    trigger.addEventListener('click', function () {
      target.click();
    });

    var sync = function () {
      trigger.disabled = target.disabled || target.getAttribute('aria-disabled') === 'true';
      trigger.setAttribute('aria-busy', target.classList.contains('loading') ? 'true' : 'false');
      if (label) {
        // The buy button also carries its price; the bar shows price separately.
        var atcPrice = target.querySelector('[data-tw-atc-price]');
        var text = target.textContent;
        if (atcPrice) text = text.replace(atcPrice.textContent, '');
        label.textContent = text.trim();
      }
      var apparel = target.closest('[data-apparel-root]');
      var context = bar.querySelector('[data-tw-sticky-context]');
      if (apparel && context) {
        var selectedSize = apparel.querySelector('[data-size-required] [aria-pressed="true"]');
        var selectedColour = apparel.querySelector('[data-option-position="1"] [aria-pressed="true"]');
        var summary = apparel.dataset.sizeChosen === 'true' && selectedSize
          ? [selectedSize.textContent.trim(), selectedColour?.dataset.displayValue].filter(Boolean).join(' · ')
          : '';
        if (context.textContent !== summary) context.textContent = summary;
      }
    };

    sync();
    new MutationObserver(sync).observe(target, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    // Variant updates replace the buy box. Read its current price when syncing.
    var price = bar.querySelector('[data-tw-sticky-price]');
    var productSection = target.closest('product-info') || target.closest('[data-apparel-root]');
    if (price && productSection) {
      var syncPrice = function () {
        var current = productSection.querySelector('.price .price-item--sale') || productSection.querySelector('.price .price-item--regular');
        var priceBox = productSection.querySelector('.price');
        if (priceBox && !priceBox.classList.contains('price--on-sale')) current = priceBox.querySelector('.price-item--regular');
        if (!current) current = productSection.querySelector('[data-apparel-price]');
        if (current && price.textContent.trim() !== current.textContent.trim()) price.textContent = current.textContent.trim();
      };
      new MutationObserver(syncPrice).observe(productSection, { childList: true, subtree: true });
      syncPrice();
    }

    var frame;
    var updateVisibility = function () {
      frame = null;
      var bounds = target.getBoundingClientRect();
      var consentInset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--aleona-consent-inset')) || 0;
      var targetVisible = bounds.top >= 96 && bounds.bottom <= window.innerHeight - consentInset - 16;
      bar.classList.toggle('is-visible', !targetVisible);
    };
    var requestUpdate = function () {
      if (frame) return;
      frame = window.requestAnimationFrame(updateVisibility);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('aleona:purchase-inset', requestUpdate);
    updateVisibility();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAleonaStickyCart, { once: true });
} else {
  initializeAleonaStickyCart();
}

document.addEventListener('shopify:section:load', initializeAleonaStickyCart);

